import Requests from "@/services/Requests";

const state = {
  bankAccounts: {
    status: "unitiliazed", // unitiliazed, loading, success, error
    data: [],
    count: 0,
  },
  allBankAccounts: {
    status: "unitiliazed",
    data: [],
    count: 0,
  },
  createStatus: "unitiliazed",
  updateStatus: "unitiliazed",
  deleteStatus: "unitiliazed",
};

const getters = {
  getBankAccounts:
    (state) =>
    (page = 0) =>
      page === 0
        ? state.bankAccounts.data
        : state.bankAccounts.data
            .filter(
              (value, index, self) =>
                index === self.findIndex((t) => t.id === value.id)
            )
            .filter((d) => d.page === page),
  getAllBankAccounts: (state) => state.allBankAccounts.data,
  getBankAccountStatus: (state) => state.bankAccounts.status,
  getBankAccountCount: (state) => state.bankAccounts.count,
  getBankAccountsLoading: (state) => state.bankAccounts.status === "loading",
};

const mutations = {
  SET_BANK_ACCOUNT_STATUS(state, payload) {
    state.bankAccounts.status = payload;
  },
  SET_BANK_ACCOUNTS(state, payload) {
    state.bankAccounts.data = payload.items;
    state.bankAccounts.count = payload.count;
  },
  SET_ALL_BANK_ACCOUNTS(state, payload) {
    state.allBankAccounts.data = payload.items;
    state.allBankAccounts.count = payload.count;
  },
  SET_UPDATE_BANK_ACCOUNT_STATUS(state, payload) {
    state.updateStatus = payload;
  },
  SET_UPDATE_BANK_ACCOUNT(state, payload) {
    const index = state.bankAccounts.data.findIndex((d) => d.id === payload.id);
    if (index === -1) return;
    const bankAccount = state.bankAccounts.data[index];
    state.bankAccounts.data[index] = { ...bankAccount, ...payload };
  },
  SET_CREATE_BANK_ACCOUNT_STATUS(state, payload) {
    state.createStatus = payload;
  },
  SET_CREATE_BANK_ACCOUNT(state, payload) {
    state.bankAccounts.data.push(payload);
  },
  SET_DELETE_BANK_ACCOUNT_STATUS(state, payload) {
    state.deleteStatus = payload;
  },
  SET_DELETE_BANK_ACCOUNT(state, payload) {
    state.bankAccounts.data = state.bankAccounts.data.filter(
      (d) => d.id !== payload.id
    );
  },
};

const actions = {
  async getBankAccounts({ commit, state }, payload) {
    const status = state.bankAccounts.status;
    commit("SET_BANK_ACCOUNT_STATUS", "loading");
    const response = await Requests.BankAccount.BankAccountDetails(payload);
    if (response.message === "OK") {
      const items = (response.data?.items || response.data || []).map(
        (item) => ({
          ...item,
          page: payload.query?.page || 1,
        })
      );
      const count = response.data?.count ?? items.length;
      commit("SET_BANK_ACCOUNTS", { items, count });
      if (status === "unitiliazed")
        commit("SET_ALL_BANK_ACCOUNTS", { items, count });
    }
    commit("SET_BANK_ACCOUNT_STATUS", "success");
    return response.message;
  },
  async createBankAccount({ state, commit }, payload) {
    state.createStatus = "loading";
    try {
      const response = await Requests.BankAccount.Create(payload);
      state.createStatus = "success";
      if (response.message === "OK")
        commit("SET_CREATE_BANK_ACCOUNT", {
          id: response.data,
          name: payload.name,
          currency: payload.currency,
          parasutInfo: payload.parasutInfo,
          mikroInfo: payload.mikroInfo,
          balance: 0,
          isActive: true,
          page: 1,
        });
      else state.createStatus = "error";
      return response;
    } catch {
      state.createStatus = "error";
      return { message: "ERROR" };
    }
  },
  async updateBankAccount({ state, commit }, payload) {
    state.updateStatus = "loading";
    try {
      const { id, ...form } = payload;
      const response = await Requests.BankAccount.Update(form, {
        params: { id },
      });
      if (response.message === "OK") {
        commit("SET_UPDATE_BANK_ACCOUNT", payload);
        state.updateStatus = "success";
      } else {
        state.updateStatus = "error";
      }
      return response;
    } catch {
      state.updateStatus = "error";
      return { message: "ERROR" };
    }
  },
  removeBankAccount({ state }, { id }) {
    state.deleteStatus = "loading";

    return Requests.BankAccount.Delete({ params: { id } })
      .then((response) => {
        state.deleteStatus = response.message === "OK" ? "success" : "error";
        return response;
      })
      .catch(() => {
        state.deleteStatus = "error";
        return { message: "ERROR" };
      });
  },
};

export default { state, getters, mutations, actions };
